<template>
  <v-container
    fluid
    grid-list-md
  >

    <v-card>
      <card-toolbar title="Alt Kullanıcı"></card-toolbar>
      <v-card-text>
        <v-alert type="warning" border="left" colored-border elevation="2" class="mb-3">
          <strong>01.04.2026</strong> itibarıyla SMS gönderim arayüzlerine erişim yalnızca aboneliğin yetkilisi veya SMS göndermeye yetkili kişi tarafından <strong>e-İmza</strong> ile yapılabilecektir.
          SMS gönderim yetkisi olan Alt Kullanıcılar için <strong>TC Kimlik Numarası</strong> alanının doldurulması gerekir.
        </v-alert>
        <v-flex xs12>
          <v-layout
            row
            wrap
          >
            <v-flex
              md4
              xs12
            >
              <!-- FORM -->
              <v-form
                ref="form"
                lazy-validation
                class="px-2"
              >
                <v-layout row>
                  <span class="title">Hızlı Oluştur</span>
                  <v-flex xs12>
                    <v-text-field
                      label="Ad"
                      v-model="form.name"
                      :rules="[$rules.empty('Ad')]"
                      required
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Soyad"
                      :rules="[$rules.empty('Soyad')]"
                      required
                      v-model="form.surname"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="form.identity"
                      label="TC Kimlik Numarası"
                      prepend-inner-icon="mdi-card-account-details-outline"
                      :rules="[tcKimlikRule]"
                      maxlength="11"
                      counter="11"
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
                          </template>
                          <span>SMS gönderiminde E-İmza doğrulaması için gereklidir</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Kullanıcı Adı"
                      :rules="[$rules.empty('Kullanıcı Adı')]"
                      required
                      v-model="form.username"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Şifre"
                      :rules="[$rules.empty('Şifre')]"
                      type="password"
                      required
                      v-model="form.password"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Telefon Numarası"
                      :rules="[$rules.empty('Telefon Numarası')]"
                      required
                      v-model="form.phone"
                      v-mask="'0(###) ### ## ##'"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <SmsVerification
                        :phone="form.phone"
                        @emitVerification="emitVerification"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md4
                  >
                    <v-text-field
                      v-model="form.credit_limit"
                      :rules="[$rules.empty('SMS Kredi Limiti')]"
                      label="SMS Kredi Limiti"
                      type="number"
                      required
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    md4
                  >
                    <v-text-field
                      v-model="form.wp_credit"
                      :rules="[$rules.empty('Whatsapp Kredi Limiti')]"
                      label="Whatsapp Kredi Limiti"
                      type="number"
                      required
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    md4
                  >
                    <v-select
                      v-model="form.contacts"
                      required
                      :rules="[
                          $rules.required({
                            falseValues: [null],
                            message: 'Rehber yetkisi seçin',
                          }),
                        ]"
                      :items="[{k: 1, v: 'Yetkili'}, {k: 0, v: 'Yetkili Değil'}]"
                      item-text="v"
                      item-value="k"
                      label="Rehber Yetkisi"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12>
                    <senders-or-message-types
                      label="Gönderici Adı"
                      default="Hepsi"
                      no-data-text="Aktif Gönderici Adı bulunmuyor"
                      required
                      :rules="[$rules.empty('Gönderici Adı')]"
                      :items="senders"
                      :solo="false"
                      @on:model-update="selectedSender"
                    >
                    </senders-or-message-types>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="E-mail"
                      :rules="[
                              $rules.empty('E-mail'),
                              $rules.email
                            ]"
                      required
                      v-model="form.email"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <div class="text-right">
                  <v-btn
                    color="primary"
                    @click="createSubUser"
                  >Oluştur</v-btn>
                </div>
              </v-form>
            </v-flex>

            <v-divider vertical></v-divider>

            <v-flex
              md7
              xs12
            >
              <skeletal-loader type="article">
                <!-- TABLE -->
                <v-data-table
                  hide-default-footer
                  :headers="headers"
                  :items="items"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          medium
                          @click="prepareUpdateSubUser(item.id)"
                          class="mr-2"
                        >
                          edit
                        </v-icon>
                      </template>
                      <span>Alt Kullanıcı Bilgilerini Güncelle</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          medium
                          @click="deleteSubUser(item.id)"
                        >
                          delete
                        </v-icon>
                      </template>
                      <span>Alt Kullanıcıyı Sil</span>
                    </v-tooltip>
                    <v-btn
                      text
                      @click.stop="logInSubUser(item.id)"
                    >Giriş</v-btn>

                  </template>
                </v-data-table>
              </skeletal-loader>
              <pagination
                :pagination="pagination"
                :action="onPagination"
              >
              </pagination>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-text>
    </v-card>

    <update-sub-user
      v-show="update.isUpdating"
      :valid="update.isUpdating"
      :senders="update.senders"
      :data="update.data"
      @on:close="update.isUpdating = false"
      @on:save="updateSubUser"
    >
    </update-sub-user>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import CardToolbar from '../../../Components/CardToolbar.vue';
import UpdateSubUser from '../../../Components/SubUser/UpdateSubUser.vue';
import Pagination from '../../../Components/Datatables/Pagination.vue';
import SendersOrMessageTypes from '../../../Components/SMSConstants/SendersOrMessageTypes.vue';
import SkeletalLoader from '../../../Components/SkeletalLoader.vue';
import SmsVerification from "../../../Components/SmsVerification.vue";

export default {
  name: 'Index',
  components: {
    SkeletalLoader,
    SendersOrMessageTypes,
    Pagination,
    UpdateSubUser,
    CardToolbar,
    SmsVerification,
  },
  data: () => ({
    pagination: {
      current: 1,
      total: 0,
    },
    headers: [
      {
        text: 'Ad',
        value: 'name',
      },
      {
        text: 'Soyad',
        value: 'surname',
      },
      {
        text: 'Telefon Numarası',
        value: 'phone',
      },
      {
        text: 'TC Kimlik No',
        value: 'identity',
      },
      {
        text: 'İşlemler',
        value: 'actions',
      },
    ],
    items: [],
    senders: [],
    form: {
      phone: '',
      contacts: null,
      // contacts: false,
    },
    update: {
      isUpdating: false,
      data: {},
      senders: [],
    },
  }),
  watch: {
    // eslint-disable-next-line func-names
    'form.phone': function (nv) {
      if (typeof nv === 'string') {
        this.form.phone = this.$mask.unmasked(this.form.phone);
      }
    },
  },
  created() {
    this.onPagination();
  },
  methods: {
    ...mapActions({ send: 'sendBackend', login: 'login' }),
    tcKimlikRule(val) {
      if (!val || val.length === 0) return true;
      if (val.length !== 11 || !/^\d{11}$/.test(val)) return 'Geçersiz TC Kimlik Numarası';
      if (val[0] === '0') return 'Geçersiz TC Kimlik Numarası';
      const d = val.split('').map(Number);
      const sumOdd = d[0] + d[2] + d[4] + d[6] + d[8];
      const sumEven = d[1] + d[3] + d[5] + d[7];
      if (d[9] !== (sumOdd * 7 - sumEven) % 10) return 'Geçersiz TC Kimlik Numarası';
      if (d[10] !== (d[0]+d[1]+d[2]+d[3]+d[4]+d[5]+d[6]+d[7]+d[8]+d[9]) % 10) return 'Geçersiz TC Kimlik Numarası';
      return true;
    },
    selectedSender(v) {
      this.form.sender = v;
    },
    emitVerification(data) {
      this.form = {
        ...this.form,
        ...data,
      };
    },
    prepareUpdateSubUser(id) {
      this.update.isUpdating = true;
      const route = 'show/subuser/single';
      const data = { id };
      this.send({
        route,
        data,
      }).then(async (res) => {
        this.update.data = await res.data.data.subUser;
        this.update.senders = res.data.data.senders;
        this.update.senders.unshift('Hepsi');
        const allowedFields = [
          'id',
          'name',
          'surname',
          'username',
          'phone',
          'email',
          'wp_credit',
          'sub_user_settings',
          'identity',
        ];
        this.update.data = Object.filterByKey(allowedFields, this.update.data);
      });
    },
    async updateSubUser(val) {
      const route = 'update/subuser';
      this.send({
        route,
        data: val,
      }).then(async () => {
        this.update.isUpdating = false;
        this.loadSubUsersAsync();
      });
    },
    onPagination() {
      const route = `show/subuser?page=${this.pagination.current}`;
      this.send({ route }).then((res) => {
        this.senders = res.data.data.senders;

        this.senders.unshift('Hepsi');
        this.items = res.data.data.subUsers.data;
        this.pagination.current = res.data.data.subUsers.current_page;
        this.pagination.total = res.data.data.subUsers.last_page;
      });
    },
    deleteSubUser(id) {
      this.$store.commit('fireConfirmation', () => {
        const route = 'delete/subuser';
        const data = { id };
        this.send({
          route,
          data,
        }).then(() => {
          this.items = this.items.filter(el => el.id !== id);
        });
      });
    },
    async loadSubUsersAsync() {
      const route = `show/subuser?page=${this.pagination.current}`;
      this.$store.dispatch('asyncSender', { route }).then((res) => {
        this.senders = res.data.data.senders;
        this.senders.unshift('Hepsi');
        this.items = res.data.data.subUsers.data;
        this.pagination.current = res.data.data.subUsers.current_page;
        this.pagination.total = res.data.data.subUsers.last_page;
      });
    },
    async createSubUser() {
      if (this.$refs.form.validate()) {
        if (this.form.sender === "Hepsi") {
          this.form.sender = "all";
        }
        const route = "add/subuser";
        this.send({
          route,
          data: this.form,
        }).then(async () => {
          this.$refs.form.reset();
          this.loadSubUsersAsync();
        });
      }
    },
    logInSubUser(userId) {
      this.login({ logInSubUser: true, sub_user_id: userId }).then(() => this.$router.push({ name: 'dashboard' }));
    },
  },
};
</script>

<style scoped>
</style>
